module.exports = __webpack_public_path__ + "img/pressure.205aab2c.svg";